import { createContext } from 'react';

import type { ThemeChoice } from './theme-store';

export interface ThemeState {
  theme: ThemeChoice;
  setTheme(choice: ThemeChoice): void;
}

export const ThemeContext = createContext<ThemeState | null>(null);
